export default __webpack_public_path__ + "static/media/youtube.5213846a.svg";